// extracted by mini-css-extract-plugin
export default {"mainLayout":"AppLayoutStyles_mainLayout__feLau","layout":"AppLayoutStyles_layout__iT2j4"};